/** Query params for GET /client/efficacy — backend accepts robotId and/or email. */
export function efficacyParamsFromHospital(hospitalInfo, email) {
  const robotId =
    hospitalInfo?.robotId ?? hospitalInfo?.primaryRobotId ?? hospitalInfo?.defaultRobotId ?? hospitalInfo?.robotID;
  if (robotId) return { robotId: String(robotId).trim() };
  if (email) return { email };
  return null;
}

/** Params for GET /client/efficacy/months (navigator bounds). */
export function efficacyMonthsParams(base) {
  if (!base) return null;
  return { ...base };
}

/** Base params plus required month scope (backend `calcMonth`). */
export function efficacyParamsWithCalcMonth(base, calcMonth, tz) {
  if (!base) return null;
  const out = { ...base };
  if (calcMonth) out.calcMonth = calcMonth;
  if (tz) out.tz = tz;
  return out;
}
